import { format } from 'date-fns';
/**
 * The name every download we produce is saved under, in the admin, the
 * business dashboard and the server's emailed exports:
 * `afriex_<what>[_<scope>]_<YYYY-MM-DD>_<HHmmss>.<extension>`. The timestamp is
 * the runtime's local time, so a browser stamps the downloader's clock and the
 * server stamps its own.
 *
 * `scope` is the one business, customer, transaction or invoice the file
 * covers; a filtered list has none. It is lowercased and anything outside
 * a-z, 0-9 and `-` becomes `_`, so a business name is safe in a filename.
 * Pure and runtime-agnostic so every surface shares one convention.
 */
export function buildDownloadFileName(what, extension, scope) {
    const scopePart = scope
        ?.toLowerCase()
        .replace(/[^a-z0-9-]+/g, '_')
        .replace(/^_+|_+$/g, '');
    const parts = [
        'afriex',
        what,
        scopePart,
        format(new Date(), 'yyyy-MM-dd_HHmmss'),
    ];
    return `${parts.filter(Boolean).join('_')}.${extension}`;
}
//# sourceMappingURL=downloadFileName.js.map